import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from './axios';

export const startPositionSharing = createAsyncThunk(
    'hunter/start-sharing',
    async ({
        data,
    }: {
        data: {
            user_id?: number;
            device_id?: number;
            group_id?: number;
            id?: number;
        };
    }) => {
        const url =
            data.device_id && data.user_id
                ? `sharing/admin/start/${data.device_id}/${data.user_id}`
                : data.device_id && data.group_id
                  ? `sharing/admin/group/start/${data.device_id}/${data.group_id}`
                  : data.user_id
                    ? `sharing/user/start/${data.user_id}?time=${new Date().getTime()}`
                    : `sharing/device/start/${data.id}?time=${new Date().getTime()}`;
        const response = await axios.get(url);

        if (response.status === 200 && typeof response.data === 'object') {
            return true;
        } else {
            return false;
        }
    },
);

export const endPositionSharing = createAsyncThunk(
    'hunter/end-sharing',
    async ({
        data,
    }: {
        data: {
            user_id?: number;
            device_id?: number;
            group_id?: number;
            id?: number;
        };
    }) => {
        const url =
            data.device_id && data.user_id
                ? `sharing/admin/end/${data.device_id}/${data.user_id}`
                : data.device_id && data.group_id
                  ? `sharing/admin/group/end/${data.device_id}/${data.group_id}`
                  : data.user_id
                    ? `sharing/user/end/${data.user_id}?time=${new Date().getTime()}`
                    : `sharing/device/end/${data.id}?time=${new Date().getTime()}`;
        const response = await axios.get(url);

        if (response.status === 200 && typeof response.data === 'object') {
            return true;
        } else {
            return false;
        }
    },
);

export const getAllCommands = createAsyncThunk('get/commands', async () => {
    const response = await axios.get('devices/commands');

    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});
